// extracted by mini-css-extract-plugin
module.exports = {"container":"snippet_actions-module__container--1T6Iz","button":"snippet_actions-module__button--3ntQJ","label":"snippet_actions-module__label--2U81L"};